import { EyeSalesAnalyticsIcon } from '@components/icons/EyeSalesAnalyticsIcon'
import { PreReadIcon } from '@components/icons/PreReadIcon'
import React from 'react'

import { EbookSaleAnalyticsDetailProps } from './interface'

export const EbookSaleAnalyticsDetail = ({
  totalSales,
  buyCount,
  viewCount,
  preReadCount,
  ebookId,
}: EbookSaleAnalyticsDetailProps) => {
  return (
    <div className='grid grid-cols-2 gap-[20px] text-[16px] mobile:text-[14px]'>
      {ebookId ? (
        <>
          <div className='flex mobile:flex-col mobile:col-span-2 items-baseline mobile:items-center justify-center py-[30px] mobile:py-[14px] bg-sale-analytic bg-cover w-full rounded-[8px] text-center font-light text-white-1'>
            รายได้จากการขาย
            <span className='text-[32px] mobile:text-[24px] font-bold mx-[15px] text-white'>
              {totalSales?.toLocaleString()}
            </span>
            เหรียญ
          </div>
          <div className='flex mobile:flex-col mobile:col-span-2 items-baseline mobile:items-center justify-center py-[30px] mobile:py-[14px] bg-sale-analytic bg-cover w-full rounded-[8px] text-center font-light text-white-1'>
            จำนวนที่ขาย
            <span className='text-[32px] mobile:text-[24px] font-bold mx-[15px] text-white'>
              {buyCount?.toLocaleString()}
            </span>
            ครั้ง
          </div>
        </>
      ) : (
        <div className='flex mobile:flex-col items-baseline mobile:items-center justify-center col-span-2 py-[30px] mobile:py-[14px] bg-sale-analytic bg-cover w-full rounded-[8px] text-center font-light text-white-1'>
          รายได้จากการขาย
          <span className='text-[32px] mobile:text-[24px] font-bold mx-[15px] text-white'>
            {totalSales?.toLocaleString()}
          </span>
          เหรียญ
        </div>
      )}
      <div className='flex text-secondary-1 mobile:text-[14px] flex-col items-center justify-center shadow-card bg-white dark:bg-dark-9 rounded-[8px] border border-gray-4 dark:border-dark-9 py-[30px] font-light'>
        <div className='flex w-[120px] h-[120px] bg-gray-4 dark:bg-dark-10 rounded-full justify-center items-center mobile:w-[58px] mobile:h-[58px]'>
          <EyeSalesAnalyticsIcon
            className='text-primary mobile:w-[28px] mobile:h-[28px]'
            width='56px'
            height='56px'
          />
        </div>
        <span className='text-[32px] tablet-mobile:text-[24px] font-bold text-secondary mt-[8px] mb-[12px] dark:text-dark-10'>
          {viewCount.toLocaleString()}
        </span>
        ยอดวิว
      </div>
      <div className='flex text-secondary-1 flex-col items-center justify-center shadow-card bg-white dark:bg-dark-9 rounded-[8px] border border-gray-4 dark:border-dark-9 py-[30px] font-light'>
        <div className='flex w-[120px] h-[120px] bg-gray-4 dark:bg-dark-10 rounded-full justify-center items-center mobile:w-[58px] mobile:h-[58px]'>
          <PreReadIcon
            className='text-primary mobile:w-[27px] mobile:h-[27px]'
            width='56px'
            height='56px'
          />
        </div>
        <span className='text-[32px] tablet-mobile:text-[24px] font-bold text-secondary mt-[8px] mb-[12px] dark:text-dark-10'>
          {preReadCount.toLocaleString()}
        </span>
        จำนวนตอนทดลองอ่าน
      </div>
    </div>
  )
}
